module.exports = __webpack_public_path__ + "static/img/warehouse4.5de3aa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/warehouse4.png
// module id = OlnP
// module chunks = 1